<div class="mt-3">
  <h4 class="mb-3">{{ title() }}</h4>
  @if (isGeneralRates) {
    <div class="d-flex gap-3">
      <gstar-rates-manager
        [securityTaxResultItem]="securityTaxResultItem()"
        [isReadonly]="isDisabled()" />
      @if (securityTaxResultItem().items().at(0)!.explanation) {
        <gstar-explanation-field
          class="flex-fill"
          [isDisabled]="isDisabled()"
          [securityTaxResultItemForm]="securityTaxResultItem().items().at(0)!"
          [title]="title()"
          (update)="updateAllFieldExplanationHandler($event)" />
      }
    </div>
  } @else {
    @for (
      item of securityTaxResultItem().items();
      track index;
      let index = $index
    ) {
      @if (item.questionText) {
        <p class="mb-2">
          <strong>
            {{ item.questionText }}
          </strong>
        </p>
      }
      <div>
        @if (item.questionText) {
          <gstar-yes-no [value]="item.yesNoValue" />
        }
        <div class="d-flex gap-3">
          @if (item.rate) {
            <gstar-rate-field
              class="column-tax-result flex-shrink-0"
              [isDisabled]="isDisabled()"
              [securityTaxResultItemForm]="item"
              (update)="updateFieldHandler($event)" />
          }
          @if (item.explanation) {
            <gstar-explanation-field
              class="col-10"
              [isDisabled]="isDisabled()"
              [securityTaxResultItemForm]="item"
              [title]="title()"
              (update)="updateFieldHandler($event)" />
          }
        </div>
      </div>
    }
  }
</div>
